// The dashboard's URL. Members: /league/:leagueId/:tab. Shared viewers:
// /s/:token/:tab, with the Overview at /s/:token itself.
export const TAB_IDS = ['home', 'recap', 'playoffs', 'stats', 'team', 'history'];
export const STATS_VIEWS = ['power', 'scoring', 'whatif'];

export function isTabId(tab) {
  return TAB_IDS.includes(tab);
}

export function statsViewOf(param) {
  return STATS_VIEWS.includes(param) ? param : STATS_VIEWS[0];
}

export function tabPath({ leagueId, shareToken, tab }) {
  if (shareToken) return tab === 'home' ? `/s/${shareToken}` : `/s/${shareToken}/${tab}`;
  return `/league/${leagueId}/${tab}`;
}

// `search` (a string or URLSearchParams) with `changes` applied; a null value
// removes the key. Returns '' or a string starting with '?'.
export function searchWith(search, changes) {
  const params = new URLSearchParams(search);
  for (const [key, value] of Object.entries(changes)) {
    if (value == null) params.delete(key);
    else params.set(key, String(value));
  }
  const text = params.toString();
  return text ? `?${text}` : '';
}

const enc = encodeURIComponent;

// What a league URL shows: a tab, a detail page, the bare league (→ Overview), or nothing.
export function leaguePage(params, pathname) {
  if (params.a != null || params.b != null) return params.a && params.b ? { kind: 'rivalry', a: params.a, b: params.b } : { kind: 'invalid' };
  if (params.key != null) return { kind: 'manager', key: params.key };
  if (/\/season\/?$/.test(pathname)) return { kind: 'season' };
  if (params.tab == null) return { kind: 'index' };
  return isTabId(params.tab) ? { kind: 'tab', tab: params.tab } : { kind: 'invalid' };
}

const root = ({ leagueId, shareToken }) => (shareToken ? `/s/${shareToken}` : `/league/${leagueId}`);
export const rivalryPath = ({ a, b, ...where }) => `${root(where)}/rivalry/${enc(a)}/${enc(b)}`;
export const managerPath = ({ key, ...where }) => `${root(where)}/manager/${enc(key)}`;
export const seasonPath = (where) => `${root(where)}/season`;

// A viewer's franchise alias: m followed by a number with no leading zero.
export const isAlias = (key) => /^m[1-9][0-9]*$/.test(key);

// One URL per rivalry: members by code-point order of the franchise keys
// (lexical, as the backend sorts them: no franchise key is all digits),
// viewers by alias number. Viewer keys must be distinct aliases (isAlias).
export function canonicalPair(a, b, { viewer }) {
  const first = viewer ? Number(a.slice(1)) < Number(b.slice(1)) : a < b;
  return first ? [a, b] : [b, a];
}
